class TrResponsiveVideo extends HTMLElement {
	selectors = {
		desktopTemplate: '[data-tr-js-responsive-video-desktop]',
		mobileTemplate: '[data-tr-js-responsive-video-mobile]',
	}

	attributes = {}

	stateClasses = {}

	connectedCallback() {
		this.desktopTemplateElement = this.querySelector(this.selectors.desktopTemplate)
		this.mobileTemplateElement = this.querySelector(this.selectors.mobileTemplate)
		this.mediaQuery = window.matchMedia('(max-width: 990px)')
		this.init()
		this.bindEvents()
		document.addEventListener('shopify:section:load', this.onSectionLoad)
	}

	disconnectedCallback() {
		document.removeEventListener('shopify:section:load', this.onSectionLoad)
		this.destroy()
	}

	init() {
		this.renderVideo()
	}

	bindEvents() {
		this.mediaQuery.addEventListener('change', this.onViewportChange)
	}

	onSectionLoad = (event) => {
		if (this.dataset.trJsResponsiveVideoSectionId !== event.detail.sectionId) return

		this.destroy()
		this.init()
		this.bindEvents()
	}

	onViewportChange = () => {
		this.renderVideo()
	}

	renderVideo() {
		const nextTemplateElement = this.mediaQuery.matches
			? this.mobileTemplateElement
			: this.desktopTemplateElement

		if (nextTemplateElement === this.activeTemplateElement) return

		this.removeVideoFrame()
		this.activeTemplateElement = nextTemplateElement

		if (!nextTemplateElement) return

		this.videoFrameElement = nextTemplateElement.content.firstElementChild.cloneNode(true)
		this.append(this.videoFrameElement)
	}

	removeVideoFrame() {
		this.videoFrameElement?.remove()
		this.videoFrameElement = null
	}

	destroy() {
		this.mediaQuery?.removeEventListener('change', this.onViewportChange)
		this.removeVideoFrame()
		this.activeTemplateElement = null
	}
}

if (!customElements.get('tr-responsive-video')) {
	customElements.define('tr-responsive-video', TrResponsiveVideo)
}
